// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useGlobalState } from '../globalState/GlobalStateProvider';
import { QRCode as QR } from 'react-qr-code';

const Img = styled.img`
    width: 10%;
`

const QRCode = ({ data, ...props }) => {
    const { state: {
        isOffline
    } } = useGlobalState();

    const [dataSrc, setDataSrc] = useState(data)

    useEffect(() => {
        setDataSrc(data)
    }, [data])

    if (isOffline) return null;

    return (
        <QR
            size={256}
            style={{ height: "100px", maxWidth: "100%", width: "100%" }}
            value={dataSrc}
            viewBox={`0 0 256 256`}
        />
    )
}

export default QRCode;